import { create } from 'zustand'

type PreviewRailState = {
  /** rail 是否展开 */
  open: boolean

  /** 用于强制重载 Chat（remount） */
  resetKey: number

  /** 当前预览的会话 ID */
  previewSessionId: string | null

  /** 是否正在重启预览 */
  isRestarting: boolean

  /** 打开预览 rail */
  openRail: () => void

  /** 关闭预览 rail */
  close: () => void

  /** 重载预览内容（基于已保存版本） */
  reload: () => void

  /** 设置预览会话 */
  setPreviewSession: (sessionId: string) => void

  /** 清空预览会话 */
  clearPreviewSession: () => void

  /** 设置重启状态 */
  setRestarting: (isRestarting: boolean) => void
}

export const usePreviewRailStore = create<PreviewRailState>((set) => ({
  open: false,
  resetKey: 0,
  previewSessionId: null,
  isRestarting: false,

  openRail: () => set({ open: true }),

  close: () => set({ open: false }),

  reload: () =>
    set((s) => ({
      resetKey: s.resetKey + 1,
    })),

  setPreviewSession: (sessionId) =>
    set({
      previewSessionId: sessionId,
    }),

  clearPreviewSession: () =>
    set({
      previewSessionId: null,
    }),

  setRestarting: (isRestarting) =>
    set({
      isRestarting,
    }),
}))
